import classNames from 'classnames';
import React from 'react';
import confettiImage from 'assets/images/confetti.png';
import { DownloadAppArea } from 'components/DownloadAppArea/DownloadAppArea';
import { CheckIcon } from 'components/Icons';
import { PaneBottomContactPanel } from 'components/PaneBottomContactPanel/PaneBottomContactPanel';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { SUPPORT_EMAIL } from '../../../../../../configConsts';
import style from './SuccessPane.scss';

interface Props {
  description: string;
}

export const SuccessPane: React.FC<Props> = ({ description }) => {
  return (
    <div className={style.paneContainer}>
      <div className={classNames(style.paneContentWrapper, style.customContentWrapper)}>
        <img src={confettiImage} className={style.backgroundImage} alt="Confetti" />
        <div className={style.checkImageWrapper}>
          <CheckIcon color={Color.WHITE} />
        </div>
        <div className={style.textWrapper}>
          <Text variant="h5">You’re all set!</Text>
          <Text variant="md" color={Color.GRAY_800}>
            {description}
          </Text>
        </div>
        <DownloadAppArea />
      </div>
      <PaneBottomContactPanel email={SUPPORT_EMAIL} isMobileHidden />
    </div>
  );
};
